import { ace_index } from '@axo/shared/data-access/types';
import { SearchResults } from '../../../components/SearchResults';
import { QuickSearchFilters } from '../../../components/QuickSearchFilters';
import {
  useQuickSearchActions,
  useQuickSearchColumns,
  useQuickSearchQuery,
} from '../../../store';

interface Props {
  marketCountry: string;
}

export function QuickSearchTab({ marketCountry }: Props) {
  const query = useQuickSearchQuery();
  const columns = useQuickSearchColumns();
  const actions = useQuickSearchActions();

  const fullQuery: ace_index.FindInput = {
    ...query,
    LoanApplicationMarketCountry: marketCountry,
  };

  return (
    <div>
      <QuickSearchFilters
        query={fullQuery}
        setQuery={actions.replaceQuery}
        clearQuery={actions.clearQuery}
      />

      <SearchResults
        query={fullQuery}
        setQuery={actions.replaceQuery}
        columns={columns}
        setColumns={actions.replaceColumns}
        sortable
      />
    </div>
  );
}
